import axios from 'axios';
import router from '@/routers';
// import Vue from 'vue';
// import stores from '@/stores';
// import router from '@/router';
// import jError from '@/error/jError';

export default {
    generateApi() {
        const api = axios.create({
            baseURL: process.env.VUE_APP_BASE,
            headers: {
                token: localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        });
        api.interceptors.response.use(
            function(response) {
                console.log(response.headers, 'dsadsad');
                localStorage.setItem('token', response.headers.new_token);
                return response;
            },
            function(error) {
                if (error.response.status === 401) {
                    localStorage.clear();
                    router.replace('/login');
                    return Promise.reject(error);
                }

                return Promise.reject(error);
            }
        );
        return api;
    },

    generateApiLogin() {
        const api = axios.create({
            baseURL: process.env.VUE_APP_BASE,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return api;
    }
};